import template from './ko-field-view-currency.html';

class CurrencyComponentVM
{
	constructor(params)
	{
		this.params = params;
		this.value = ko_helper.safe_observable(params.value);
		this.decimals = ko_helper.safe_observable(params.decimals, 2);
		this.extra_classes = ko_helper.safe_observableArray(params.extra_classes || []);
	}
}


export default {
	name: 'ko-field-view-currency',
	viewModel: CurrencyComponentVM,
	module_type: 'ko',
	template: template
}
